import api from "../api";

export const useUserCancelReservedTokens = (id) =>
  api.put(`/reserve-token/cancel/${id}`).then((res) => res.data);
